import { combineReducers } from 'redux'
import itinerary from './itinerary-editor';

const itineraries = combineReducers({
  itinerary,
});

export default itineraries;
